export default __webpack_public_path__ + "7115eb1ccd7d4a93dc8bfed6dcfcf4c6.png";